"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _cardType = _interopRequireDefault(require("./utils/cardType"));

var _Medium = _interopRequireDefault(require("./Medium"));

var _Wide = _interopRequireDefault(require("./Wide"));

var _MobileMedium = _interopRequireDefault(require("./MobileMedium"));

var _UserProfile = _interopRequireDefault(require("./UserProfile"));

var _Small = _interopRequireDefault(require("./Small"));

var _UltraSmall = _interopRequireDefault(require("./UltraSmall"));

var _UltraSmallMobile = _interopRequireDefault(require("./UltraSmallMobile"));

var _AdminMedium = _interopRequireDefault(require("./AdminMedium"));

var _contentType = _interopRequireDefault(require("./utils/contentType"));

var ContentCard =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ContentCard, _PureComponent);

  function ContentCard() {
    (0, _classCallCheck2.default)(this, ContentCard);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ContentCard).apply(this, arguments));
  }

  (0, _createClass2.default)(ContentCard, [{
    key: "render",
    value: function render() {
      var type = this.props.type;

      switch (type) {
        case _cardType.default.Medium:
          {
            return _react.default.createElement(_Medium.default, this.props);
          }

        case _cardType.default.Wide:
          {
            return _react.default.createElement(_Wide.default, this.props);
          }

        case _cardType.default.Small:
          {
            return _react.default.createElement(_Small.default, this.props);
          }

        case _cardType.default.MobileMedium:
          {
            return _react.default.createElement(_MobileMedium.default, this.props);
          }

        case _cardType.default.UltraSmall:
          {
            return _react.default.createElement(_UltraSmall.default, this.props);
          }

        case _cardType.default.UltraSmallMobile:
          {
            return _react.default.createElement(_UltraSmallMobile.default, this.props);
          }

        case _cardType.default.AdminMedium:
          {
            return _react.default.createElement(_AdminMedium.default, this.props);
          }

        case _cardType.default.UserProfile:
          {
            return _react.default.createElement(_UserProfile.default, this.props);
          }

        default:
          return null;
      }
    }
  }]);
  return ContentCard;
}(_react.PureComponent);

ContentCard.defaultProps = {
  className: undefined,
  description: null,
  showDescription: false,
  progressInfo: null,
  dueInfo: null,
  pathInfo: null,
  certificateInfo: null,
  badgeInfo: null,
  isEnrolled: true,
  ContentNameRightContent: null,
  bottomBarInfo: null,
  showOverlay: true,
  showStartButton: false
};
ContentCard.propTypes = {
  className: _propTypes.default.string,
  contentId: _propTypes.default.string.isRequired,
  type: _propTypes.default.oneOf(Object.values(_cardType.default)).isRequired,
  name: _propTypes.default.string.isRequired,
  description: _propTypes.default.string,
  showDescription: _propTypes.default.bool,
  ContentNameRightContent: _propTypes.default.node,
  bottomBarInfo: _propTypes.default.node,
  image: _propTypes.default.string.isRequired,
  contentType: _propTypes.default.oneOf(Object.values(_contentType.default)).isRequired,
  progressInfo: _propTypes.default.shape({
    progress: _propTypes.default.number
  }),
  dueInfo: _propTypes.default.shape({
    dueDate: _propTypes.default.string
  }),
  pathInfo: _propTypes.default.shape({
    courses: _propTypes.default.number,
    checkpoints: _propTypes.default.number,
    ilts: _propTypes.default.number
  }),
  certificateInfo: _propTypes.default.object,
  badgeInfo: _propTypes.default.object,
  isEnrolled: _propTypes.default.bool,
  showOverlay: _propTypes.default.bool,
  showStartButton: _propTypes.default.bool
};
ContentCard.Type = _cardType.default;
ContentCard.ContentType = _contentType.default;
var _default = ContentCard;
exports.default = _default;